import { useContext, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { ASSET_HOST_BASE_URL } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import { getIndependentSymbol, translate, translateNumber } from "../../../helper";
import DataTable from "../../common/DataTable";
import { Loader } from "../../common/Loader";
import "./index.css";

const List = (props) => {
  const { lang } = useContext(LangContext);
  const { party } = useParams();
  let fileteredCanlidates = props.data;
  const urlParams = new URLSearchParams(window.location.search);
  let rtype = urlParams.get("type");

  let party_name = translate("all_parties", lang);
  rtype = rtype ? [rtype] : props.tab ? props.tab : ["federal"];

  fileteredCanlidates = fileteredCanlidates.filter((c) => rtype.includes(c.rtype));
  const electedCandidates = fileteredCanlidates.filter((c) => c.elected);
  let otherCandidates = fileteredCanlidates.filter((c) => !c.elected);
  otherCandidates = otherCandidates.sort((c, d) => d.vote - c.vote);

  fileteredCanlidates = [...electedCandidates, ...otherCandidates];

  if (party) {
    party_name = props.parties[party] ? props.parties[party][lang] : "";
    fileteredCanlidates = fileteredCanlidates.filter((c) => (c.party_code.toUpperCase() === party.toUpperCase() || (c.party_code.toUpperCase().match(/I+\d/) && party.toUpperCase() === "I")) && rtype.includes(c.rtype));
  }

  const constructData = (data) => {
    data = data.map((c, i) => {
      const party_code = c.party_code.match(/I+\d/) ? "I" : c.party_code;
      let symbol = party_code.toUpperCase();
      if (symbol === "I") {
        symbol = getIndependentSymbol(c.district_id, c.region_id, c.name_en);
      }
      const gender = c.gender ? c.gender : "O";
      const candidatePhoto = c.candidatephoto && c.candidatephoto.trim() !== "" ? c.candidatephoto : `https://result.election.gov.np/Images/Candidate/${c.candidateid}.jpg`;
      const partyName = props.parties[party_code] ? props.parties[party_code][lang] : party_code;
      const areaLabel = props.districtNames[c.district_id] ? props.districtNames[c.district_id][lang] + " - " + translateNumber(c.region_id, lang) : c.district_id;
      // console.log(c, 'c candidate list');
      return {
        sn_en: i + 1,
        sn: translateNumber(i + 1, lang),
        candidate: (
          <div className="sh-candidate-card-cell">
            <div className="sh-candidate-card-head">
              <div className="sh-candidate-photo-box">
                <div className={"sh-candidate-thumbnail sh-candidate-photo-modern" + (c.elected ? " winner" : "")}>
                  <img
                    src={candidatePhoto}
                    alt={c.name_en}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null; // prevents looping
                      currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
                    }}
                  />
                </div>
              </div>
              <div className="sh-candidate-main-info">
                <div className="sh-candidate-name-modern">
                  <Link to={"/candidates/profile/" + c.id + "?lang=" + lang}>{c["name_" + lang]}</Link>
                </div>
              </div>
              <div className="">
              <div class="sh-banner-winner-section">
                                    {c.elected  && <span className="sh-banner-winner">{ <img src={ "https://assets.deshsanchar.com/wp-content/uploads/2026/02/25194001/checklist2.png"} alt="winner" width="20px" height="20px" />}<span>{translate("elected", lang)}</span></span>}
                                    <span className="sh-winner data">
                                      <span>मत</span> {translateNumber(c.vote, lang)}
                                    </span>
                                  </div>
                {/* <img
                  src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                  alt={party_code}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                  }}
                /> */}
              </div>
            </div>
            <div className="sh-candidate-card-body">
              <div className="sh-party-section-modern">
                <div className="sh-party-symbol-wrap">
                  <img
                    src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                    alt={party_code}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                    }}
                  />
                </div>
                <div className="sh-party-name-modern">
                  <Link to={"/candidates/" + party_code + "?type=" + rtype + "&lang=" + lang}>{partyName}</Link>
                </div>
              </div>
              <div className="sh-candidate-meta-modern">
                <span className="sh-meta-pill">{translate("age", lang)}: {translateNumber(c.age, lang)}</span>
                <span className="sh-meta-pill">{c.gender === "M" ? translate("male", lang) : c.gender === "F" ? translate("female", lang) : translate("other", lang)}</span>
              </div>
              <div className="sh-area-cell-modern">
                <div className="sh-area-label-modern">{translate("region", lang)}</div>
                <div className="sh-area-link-modern">
                  <Link to={"/result/" + c.province_id + "/" + c.district_id + "/" + c.region_id + "?type=" + rtype + "&lang=" + lang}>{areaLabel}</Link>
                </div>
              </div>
            </div>
          </div>
        ),
        party_info: (
          <div className="sh-party-cell-modern">
            <div className="sh-party-symbol-wrap">
              <img
                src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                alt={party_code}
                onError={({ currentTarget }) => {
                  currentTarget.onerror = null; // prevents looping
                  currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                }}
              />
            </div>
            <div className="sh-party-name-modern">
              <Link to={"/candidates/" + party_code + "?type=" + rtype + "&lang=" + lang}>{partyName}</Link>
            </div>
          </div>
        ),
        area_info: (
          <div className="sh-area-cell-modern">
            <div className="sh-area-label-modern">{translate("region", lang)}</div>
            <div className="sh-area-link-modern">
              <Link to={"/result/" + c.province_id + "/" + c.district_id + "/" + c.region_id + "?type=" + rtype + "&lang=" + lang}>{areaLabel}</Link>
            </div>
          </div>
        ),
        vote: (
          <div className="sh-vote-modern">
            {/* {translateNumber(c.vote, lang)}
            {c.elected ? <span className="sh-vote-elected"> {translate("elected", lang)}</span> : ""} */}
          </div>
        ),
        photo: (
          <div className={"sh-candidate-thumbnail" + (c.elected ? " winner" : "")}>
            <img
              src={candidatePhoto}
              alt={c.name_en}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
              }}
            />
          </div>
        ),
        name_en: c.name_en,
        name_np: c.name_np,
        name: <Link to={"/candidates/profile/" + c.id + "?lang=" + lang}>{c["name_" + lang]}</Link>,
        party: <Link to={"/candidates/" + party_code + "?type=" + rtype + "&lang=" + lang}>{partyName}</Link>,
        party_all: partyName,
        party_en: props.parties[party_code] ? props.parties[party_code]["en"] : party_code,
        symbol: (
          <div className="sh-single-candidate-party">
            <img
              src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
              alt={party_code}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
              }}
            />
          </div>
        ),
        region: <Link to={"/result/" + c.province_id + "/" + c.district_id + "/" + c.region_id + "?type=" + rtype + "&lang=" + lang}>{areaLabel}</Link>,
        district_en: props.districtNames[c.district_id] ? props.districtNames[c.district_id]["en"] : c.district_id,
        district: props.districtNames[c.district_id][lang],
        age: translateNumber(c.age, lang),
        gender: c.gender === "M" ? translate("male", lang) : c.gender === "F" ? translate("female", lang) : translate("other", lang),
        candidancy: c.rtype === "federal" ? translate("parliament_member", lang) : translate("province_member", lang),
      };
    });

    return data;
  };

  const data = constructData(fileteredCanlidates);

  useEffect(() => {
    // DataTable defaults to 10 rows; force 20 rows for candidate list page.
    let attempts = 0;
    const maxAttempts = 20;
    const timer = window.setInterval(() => {
      const pageSizeSelect = document.querySelector(".sh-candidate-list .sh-select-desh");
      if (pageSizeSelect) {
        if (String(pageSizeSelect.value) !== "20") {
          pageSizeSelect.value = "20";
          pageSizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
        }
        window.clearInterval(timer);
      } else if (attempts >= maxAttempts) {
        window.clearInterval(timer);
      }
      attempts += 1;
    }, 100);

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  const headers = [
    { title: translate("sn", lang), prop: "sn", alignment: { horizontal: "center" }, isSortable: true },
    { title: translate("party_name", lang), prop: "candidate", isFilterable: true, isSortable: true },
    { title: translate("party", lang), prop: "party_info", isFilterable: true, isSortable: true },
    { title: translate("region", lang), prop: "area_info", isFilterable: true, isSortable: true },
    { title: translate("vote", lang), prop: "vote", isFilterable: false, isSortable: false },
  ];

  if (!props.fetched) {
    return <Loader />;
  }

  return (
    <div className="container sh-candidates-container">
      <div className="sh-candidate-list-header mb-4">
        <h3 className="mb-0">{translate("candidate_list", lang) }</h3>
        {/* {data.length > 0 && (
          <span className="sh-candidate-analytics">
            <Link to={"/candidates/" + (!party ? "all" : party) + "/analytics?type=" + rtype + "&lang=" + lang}>{translate("candidate_analytics", lang)}</Link>
          </span>
        )} */}
      </div>
      <div className="sh-candidate-list">
        <DataTable headers={headers} data={data} filterColumn={["name_en", "name_np", "party_en", "party_all", "district_en", "district"]} sort={{ prop: "name", order: "asc" }} view="cards" />
      </div>
    </div>
  );
};

export default List;
